import {from} from './from'

import { writable } from 'svelte/store';
import { global } from './state.js'
import { createDatasource, upload } from './datasets.js'
import {save as saveSettings} from './settings.js'

let data = {
  list:[]
};

export const store = writable(data);
store.subscribe(value => {
  data = value;
});

export function loadRecs(cb) {
  if (global.noauth) {
    return;
  }

  // load settings in dashboard call, vs here?
  from("/recs", {})
    .then((r) => r.json())
    .then(j => {
      console.group("loaded recs async")
      console.log("loaded",j.recs)
      if (j.recs) {
        // store.set({list:j.recs.map(rec=>({...rec, closeable:true}))})
        j.recs.forEach(obj => {
          // console.group("loaded recs async foreach rec")

          if (!init(obj)) {
            return;
          }
          addEphemeralRec(obj)
          // console.groupEnd();
        });
        if (cb) {
          cb(j.recs);
        }
      }
      console.groupEnd()
    })
    .catch((ex) => {
      console.error("recs.load - ex - ", ex, ex.stack);
    });
}

// export function save() {
//   saveObj(data);
// }

export function saveObj(data) {
  if (global.noauth) {
    return;
  }

  console.log("recs: saving", data)
  return from("/recs", { method: "POST", body: JSON.stringify(data) })
    .then((r) => {console.log("recs: saveObj then", r); return r})
    .then((r) => r.json())
    .then((obj) => {
      console.log("saved"); // msg panel above main tabs? event to it? store subs?
      return obj;
    })
    .catch((ex) => {
      console.error("recs: save ex - ", ex, ex.stack);
      throw ex;
    });
}

async function urlToFormdata(url) {
  var blob = await fetch(url).then(r => r.blob()).catch(e => console.log("urlToFormdata, caught", e, url));
  var fd = new FormData()
  fd.append("file", blob, new URL(url).pathname.split("/").filter(s => s.length).pop());
  return fd;
}

function blobToBase64(blob) {
  return new Promise((resolve, _) => {
    const reader = new FileReader();
    reader.onloadend = () => resolve(reader.result);
    reader.readAsDataURL(blob);
  });
}

async function formdataToDatasourceInstance(dataSource, formData) {
      
  var loc = undefined; // user file location.. usable?
  const resp = await upload(formData, dataSource.id, dataSource.name, loc, global.env.flags["ui.quickdrop.sql"] == true);
  if (!resp || !resp.uploaded) {  // or ex skips this?
    console.error("upload error - response",resp);
    return null; 
  }
  let info = resp.uploaded[0]
  console.log("uploaded - info", info);
  if (!info) { 
    console.error("upload error, no instance");
    return null; 
  }

  if (!dataSource.name) {
    dataSource.name = info.name;
  }
  dataSource.loc = info.loc;

  var instance = {
    stamp: info.uploadTimestamp,
    stage: info.stage,
    selected: false,
    uri: info.uri,
    name: dataSource.name,
    colcount: info.colcount,
    rowcount: info.rowcount,
    errcount: info.errcount,
    ...info
    }

  if (global.noauth) {
    // since the file data is not stored by upload in noauth, embed in the instance uri
    instance.uri = "data:;base64,"+btoa(formData.get("file"))
    console.log("formdataToDatasourceInstance", formData.get("file"));
    console.log("formdataToDatasourceInstance", await blobToBase64(formData.get("file")));
    instance.uri = await blobToBase64(formData.get("file"));
  }
  return instance;  
}

export async function createRecFromUrls(bootRec) {
  var dsA = await formdataToDatasourceInstance(createDatasource(), await urlToFormdata(bootRec.uriA));
  var dsB = await formdataToDatasourceInstance(createDatasource(), await urlToFormdata(bootRec.uriB));
  createRec({a:dsA,b:dsB,runImmed:true});
}

export async function createRecFromFiles(files) {

  console.log('createRecFromFiles',files)
  const datafiles = files.filter(f=> f.name != "config.csv" && f.name != "config.json" && f.name != "config.xlsx")
  const configPresent = files.length != datafiles.length;
  console.log('config sent', configPresent);
  let err;
  if (datafiles.length != 2) {
    err = '2 data files are needed for a quick rec'
  } else {
    err = null;
    // upload each file, with settings save, then createRec call, reuse existing logic esp for upload params

    var instances = [];
    for (var file in files) {
      var formData = new FormData();
      formData.append('file', files[file]);
      const dataSource = createDatasource();

      var instance = await formdataToDatasourceInstance(dataSource, formData);
      if (!instance) {
        continue;
      }

      dataSource.instances = [instance, ...dataSource.instances];
  
      saveSettings();
      
      instances.push(instance);
    }
    
    createRec({a:instances[0], b:instances[1], runImmed: true});
  }

  return err;
}

function init(obj) {
  if (!obj.a || !obj.b) {
    console.log("recs.init called without 2 sides")
    return false;
  }
  obj.label  ||= obj.a.name + " vs " + obj.b.name
  obj.name   ||= obj.label
  obj.config ||= {}
  obj.id     ||= Date.now()

  if (!obj.config.a_key || !obj.config.b_key) {
    guessKeys(obj);
  }
  if (!obj.config.columns) {
    setAllCols(obj);
  }

  return true;
}

export function createRec(obj) {
  if (!init(obj)) {
    return;
  }
  if (global.noauth) {
    addEphemeralRec(obj)
    return data;
  } else {
    return saveObj(obj)
    .then(r => {
      // data.list = [...data.list, {...obj, id:r.id, closeable:true}];
      // store.set(data);
      addEphemeralRec({...obj, id:r.id})
      return data;
    })
  }
}

export function openRec(id) {
  if (global.noauth) {
    return;
  }

  from("/recs?id="+id, { })
  .then(r => r.json())
  .then(obj => {
    // data.list = [...data.list, {...obj.rec, closeable:true}];
    // store.set(data);
    if (!init(obj)) {
      return;
    }
    addEphemeralRec(obj.rec);
  }) 
}

export function closeRec(id) {
  data.list = [...data.list].filter(x => x.id != id);
  store.set(data);
}

export function addEphemeralRec(rec) {
  data.list = [...data.list, rec];
  store.set(data);
  return rec;
}

function setAllCols(rec) { // remove rule here until assigned / matching col found? why is this split a/b maps? a side auto rule..
  rec.config.columns = [
    ...rec.a.columns.map(c => ({
      ...c, 
      side:'a', 
      compareWithCol: rec.b.columns.filter(b=>b.name === c.name && b.type === c.type).map(c=>c.name).shift()
    })), 
    ...rec.b.columns.map(c => ({...c, side:'b'}))
    ].map((col,i) => ({ ...col, 
      summary:undefined, 
      sample:undefined,
      minkeylength: undefined,
      maxkeylength: undefined,
      rule: 
        col.type === 'string' ? "string-exact" : 
        col.type === 'number' ? "number-tolerance" : 'string-exact',
      tolerance: 0,
      colIndex: i,  // unique id for UI support
      hide: (col.name !== rec.config.a_key && col.side === "a" && !col.compareWithCol) || col.unique === 1,
      format: col.type && col.type.indexOf("date") === 0 ? "date-utc" : ""
    }));
}

function guessKeys(rec) {
  var weight = { 'text':3, 'number': 2 }
  var sameColnameWeight = 10
  var singleColLengthWeight = 2

  const score = (x) => {
    if (!x.keyscore) {
      var wx = weight[x.type] || 1;
      x.keyscore = wx * (x.unique || x.count) * parseInt(10.0 * (x.minkeylength || 1) / (x.maxkeylength || 1));
      // console.log("scoring col", x.name, x.keyscore, wx, x)
    }
    return x.keyscore;
  }
  var colcmp = (x,y) => score(y) - score(x) 

  // look for matching columns, maps for lookups
  var aCols = rec.a.columns.reduce((acc,x)=>{acc[x.name]=x; return acc;}, {});
  var bCols = rec.b.columns.reduce((acc,x)=>{acc[x.name]=x; return acc;}, {});
  // console.log("guessKeys", aCols, bCols)

  const highestNameMatch = () => {
    // console.log("highestNameMatch")
    // match on name in score order
    var guessKey = rec.b.columns.filter(x => aCols[x.name]).sort(colcmp).map(x => x.name).shift();
    if (guessKey) {
      rec.config.a_key = rec.config.b_key = guessKey;
      return true
    } else {
      return false;
    }
  }

  const highestMatchingLengthsAndType = () => {
    // console.log("highestMatchingLengthsAndType")
    var a_matches = rec.a.columns.slice(0).sort(colcmp).filter(a => {
      a.b_matches = rec.b.columns.slice(0).sort(colcmp).filter(b => a.maxkeylength == b.maxkeylength)
      return a.b_matches.length
    })
    // console.log("highestMatchingLengthsAndType", a_matches)
    if (a_matches.length) {
      rec.config.a_key = a_matches[0].name;
      rec.config.b_key = a_matches[0].b_matches[0].name;
      return true
    } else {
      return false
    }
  }

  const highestAandBsameType = () => {
    // console.log("highestAandBsameType")
    var a_key_col = rec.a.columns.slice(0).sort(colcmp).shift();
    // highest a
    rec.config.a_key = a_key_col.name;

    // highest b of same type
    rec.config.b_key = rec.b.columns.slice(0).filter(x => x.type == a_key_col.type).sort(colcmp).map(x => x.name).shift();
    console.log("a cols cmp", rec.a.columns.slice(0).sort(colcmp))
    console.log("b cols cmp", rec.b.columns.slice(0).sort(colcmp))
    return !!a_key_col
  }

  highestNameMatch() || highestMatchingLengthsAndType() || highestAandBsameType()

  // console.log(rec.config.a_key,rec.config.b_key)
  
  return rec;
}
